import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Loader(_: Props) {
  return (
    <div className={styles.loader}>
      <Skeleton className={styles.icon} />
      <Skeleton className={styles.name} />
    </div>
  );
}

export { Loader };
